import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import ProductExcelBulkEditContainer from '../../containers/product/ProductExcelBulkEditContainer';
import { PRODUCT_PAGE_NAME } from '../../constants/service/app/productConstants';

const ProductBulkEdit = () => {
  return (
    <PageTemplate pageName={PRODUCT_PAGE_NAME.PRODUCT_BULK_EDIT}>
      <ProductExcelBulkEditContainer />
    </PageTemplate>
  );
};

export default ProductBulkEdit;
